var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        content: _vm.$filters.capitalize(_vm.name),
        placement: "top",
        arrow: false
      }
    },
    [
      _c("span", { class: _vm.classes, on: { click: _vm.handleClick } }, [
        _vm._v(
          "\n        " + _vm._s(_vm.$filters.capitalize(_vm.name)) + "\n    "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }